function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M128 48v416l128-96.4L384 464V48H128zm240 384l-112-84.3L144 432V64h224v368z"
});

const SvgIosBookmarkOutline = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosBookmarkOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-bookmark-outline.c0bdb57c.svg";
export { ForwardRef as ReactComponent };